var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVmware({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    x: "0px",
    y: "0px",
    width: "605px",
    height: "604px",
    viewBox: "0 0 605 604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_____1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "______________",
    transform: "matrix( 2.014007568359375, 0, 0, 2.014007568359375, -5.5,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F38B00",
    stroke: "none",
    d: " M 168.45 116.9 Q 181.4 120.85 185.4 133.85 L 185.4 182.3 223.75 182.3 223.75 182.25 229.65 182.25 229.65 182.15 230.2 182.15 230.2 99.95 Q 223.6 78.5 202.25 71.95 L 30.6 71.95 Q 9.2455078125 78.475 2.65 99.95 L 2.65 272.75 Q 9.25 294.2 31.2 299.9 L 201.65 299.9 Q 223.6 294.2 230.2 272.75 L 230.2 227.7 185.4 227.7 185.4 238.55 Q 181.4 251.55 168.1 255 L 169.25 255 168.1 255 64.8 255 63.6 255 64.8 255 Q 51.5 251.55 47.5 238.55 L 47.5 133.85 Q 51.5 120.85 64.45 116.9 L 168.45 116.9 Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#F28C00",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 64.8 255 Q 51.5 251.55 47.5 238.55 L 47.5 133.85 Q 51.5 120.85 64.45 116.9 L 168.45 116.9 Q 181.4 120.85 185.4 133.85 L 185.4 182.3 M 230.2 182.15 L 230.2 99.95 Q 223.6 78.5 202.25 71.95 L 30.6 71.95 Q 9.2455078125 78.475 2.65 99.95 L 2.65 272.75 Q 9.25 294.2 31.2 299.9 L 201.65 299.9 Q 223.6 294.2 230.2 272.75 L 230.2 227.7 M 185.4 227.7 L 185.4 238.55 Q 181.4 251.55 168.1 255 L 169.25 255 M 63.6 255 L 64.8 255 168.1 255 M 29.25 299.9 L 31.2 299.9 M 201.65 299.9 L 203.6 299.9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "______________",
    transform: "matrix( 2.014007568359375, 0, 0, 2.014007568359375, -5.5,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0097D3",
    stroke: "none",
    d: " M 303.25 28 Q 296.65 6.55 275.3 0 L 103.65 0 Q 82.3 6.55 75.7 28 L 75.7 71.95 120.5 71.95 120.5 61.9 Q 124.5 48.9 137.45 44.95 L 241.45 44.95 Q 254.4 48.9 258.4 61.9 L 258.4 166.6 Q 254.4 179.6 241.1 183.05 L 242.3 183.05 241.1 183.05 137.8 183.05 136.65 183.05 137.8 183.05 Q 124.5 179.6 120.5 166.6 L 120.5 116.9 75.7 116.9 75.7 200.8 Q 82.3 222.25 104.25 227.95 L 274.7 227.95 Q 296.65 222.25 303.25 200.8 L 303.25 28 Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#0097D3",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 75.7 116.9 L 75.7 200.8 Q 82.3 222.25 104.25 227.95 L 274.7 227.95 Q 296.65 222.25 303.25 200.8 L 303.25 28 Q 296.65 6.55 275.3 0 L 103.65 0 Q 82.3 6.55 75.7 28 L 75.7 71.95 M 120.5 71.95 L 120.5 61.9 Q 124.5 48.9 137.45 44.95 L 241.45 44.95 Q 254.4 48.9 258.4 61.9 L 258.4 166.6 Q 254.4 179.6 241.1 183.05 L 242.3 183.05 M 137.8 183.05 L 136.65 183.05 M 120.5 116.9 L 120.5 166.6 Q 124.5 179.6 137.8 183.05 L 241.1 183.05 M 104.25 227.95 L 102.3 227.95 M 276.65 227.95 L 274.7 227.95"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "____",
    transform: "matrix( 2.014007568359375, 0, 0, 2.014007568359375, -5.5,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C96D00",
    stroke: "none",
    d: " M 230.2 246.9 L 230.2 227.7 187.95 227.95 230.2 246.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0077A9",
    stroke: "none",
    d: " M 75.7 118.15 L 75.7 136.15 118.45 117.95 75.7 118.15 Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#0077A9",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 118.45 117.95 L 75.7 136.15 75.7 118.15 118.45 117.95 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#C96D00",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 187.95 227.95 L 230.2 246.9 230.2 227.7 187.95 227.95 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVmware);
export default __webpack_public_path__ + "static/media/vmware.9d894b8bbad04a55ae88c7fcf764118b.svg";
export { ForwardRef as ReactComponent };